<template>
  <div class="telaCadastro h-100">
    <HeaderNovoUsuario />
    <b-overlay :show="overlayCard">
      <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(salvarNovoUsuario)">
          <b-card header-tag="header" no-body class="m-3">
            <template #header>
              <HeaderSagres :botoes="botoesHeader" titulo="Complete seu cadastro para acessar o Portal"
                breakpoint="sm" />
            </template>
            <b-card-body>
              <b-container fluid class="mt-3">
                <p class="text-left font-weight-bold">Informações pessoais</p>
                <b-row class="w-100">
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Nome" v-slot="defaultState" rules="">
                      <b-form-input disabled id="input-nome" :state="defaultState.state" v-model="novoUsuario.NOME"
                        maxlength="80" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="CPF" v-slot="defaultState">
                      <b-form-input disabled v-model="novoUsuario.CPF" :state="defaultState.state" maxlength="11" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Email" v-slot="defaultState">
                      <b-form-input disabled v-model="novoUsuario.EMAIL" type="email" :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Telefone" v-slot="defaultState">
                      <vue-tel-input v-model="novoUsuario.TELEFONE" :props="vueTelOptions" data-1p-ignore placeholder=""
                        :state="defaultState.state" class="form-control" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Autoriza comunicação por email, SMS, ZAP ou afins"
                      v-slot="defaultState">
                      <b-form-radio-group v-model="novoUsuario.FL_COMUNICA_TELEFONE" :options="comunicaTelefoneOptions"
                        :state="defaultState.state" size="sm">
                      </b-form-radio-group>
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
                <p class="mt-3 text-left font-weight-bold">Senha (acesso sem certificado)</p>
                <b-row>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Senha (mínimo de 6 caracteres)" v-slot="defaultState">
                      <b-form-input v-model="novoUsuario.SENHA" :state="defaultState.state" placeholder="Senha"
                        type="password" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Repita a senha" v-slot="defaultState">
                      <b-form-input v-model="confirmaSenha" :state="defaultState.state" placeholder="Senha"
                        type="password" />
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
                <p class="mt-3 text-left font-weight-bold">Endereço</p>
                <b-row>
                  <b-col cols="12" md="6" xl="4">
                    <b-overlay :show="loadingMunicipios">
                      <default-form-validation-provider label="Unidade Federativa" v-slot="defaultState">
                        <b-form-select id="select-estado" :options="listaUFs" v-model="ufEscolhido"
                          :state="defaultState.state" @change="listarMunicipios" />
                      </default-form-validation-provider>
                    </b-overlay>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-overlay :show="loadingMunicipios">
                      <default-form-validation-provider label="Município" v-slot="defaultState">
                        <b-form-select id="select-municipio" v-model="novoUsuario.ID_MUNICIPIO"
                          :options="listaMunicipios" :state="defaultState.state" :disabled="!ufEscolhido" />
                      </default-form-validation-provider>
                    </b-overlay>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="CEP" v-slot="defaultState">
                      <b-form-input id="input-cep" v-model="novoUsuario.CEP" placeholder="Digite seu CEP" type="number"
                        :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Logradouro" v-slot="defaultState">
                      <b-form-input id="input-logradouro" v-model="novoUsuario.LOGRADOURO"
                        placeholder="Digite seu Logradouro" :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Número" v-slot="defaultState">
                      <b-form-input id="input-nro" placeholder="Digite o número do seu endereço"
                        v-model="novoUsuario.NUMERO" :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Complemento" v-slot="defaultState" rules="">
                      <b-form-input id="input-complemento" placeholder="Digite seu complemento"
                        v-model="novoUsuario.COMPLEMENTO" :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider label="Bairro" v-slot="defaultState" rules="">
                      <b-form-input id="input-bairro" placeholder="Digite seu bairro" v-model="novoUsuario.BAIRRO"
                        :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-body>
          </b-card>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { isNewCertUser, store, updateToken } from "@/store";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import HeaderNovoUsuario from "@/components/novo-usuario/Header.vue";
import usuarioService from "@/services/administracao/usuarioService";
import municipioService from "@/services/administracao/municipioService";
import { NovoUsuario } from "@/types/administracao/usuarios/novo-usuario";
import { SelectValue } from "@/types/select-value";
import { BotaoSagres } from "@/types/botao-sagres";
import { PortalError } from "@/types/portal-error";
import { LoginData } from "@/types/administracao/usuarios/login-data";

const CompProps = Vue.extend({
  name: "CadastroToken",
  components: {
    DefaultFormValidationProvider,
    ValidationObserver,
    HeaderNovoUsuario,
    HeaderSagres,
  },
});

@Component
export default class CadastroToken extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<typeof ValidationObserver>;
  botoesHeader: BotaoSagres[] = [{
    id: 1,
    icone: 'save',
    texto: 'Salvar',
    type: 'submit',
  }]
  comunicaTelefoneOptions = [
    { text: "Sim", value: true },
    { text: "Não", value: false },
  ];
  confirmaSenha = "";
  listaMunicipios: SelectValue[] = [];
  listaUFs: SelectValue[] = [];
  loadingMunicipios = false;
  loadingUFs = false;
  novoUsuario = new NovoUsuario();
  overlayCard = false;
  ufEscolhido = 29;

  async created() {
    try {
      store.blockScreen = true;
      if (!isNewCertUser()) {
        this.$router.push('/')
      }
    } catch (e: any) {
      console.error('Erro ao validar permissão de novo usuário com certificado digital', e)
      this.$router.push('/')
    } finally {
      store.blockScreen = false;
    }
  }

  async mounted() {
    this.novoUsuario.NOME = store.nomeUsuario ?? ''
    this.novoUsuario.CPF = store.cpf ?? ''
    this.novoUsuario.EMAIL = store.email ?? ''
    this.novoUsuario.FL_COMUNICA_TELEFONE = true
    this.obterUFs();
    this.listarMunicipios();
    this.setVueTelPlaceholder();
  }

  async obterUFs() {
    try {
      this.loadingUFs = true;
      const ufs = await municipioService.getUFs();
      this.listaUFs = ufs.map((u) => ({
        value: u.ID_UF,
        text: u.NM_SIGLA + " - " + u.NM_NOME,
      }));
    } catch (e: any) {
      this.listaUFs = [];
      this.tratarError(e);
    } finally {
      this.loadingUFs = false;
    }
  }

  async listarMunicipios() {
    try {
      if (this.ufEscolhido === 0) {
        this.listaMunicipios = [];
        return;
      }
      this.loadingMunicipios = true;
      const muns = await municipioService.getMunicipios(this.ufEscolhido);
      this.listaMunicipios = muns.map((u) => ({
        value: u.ID_MUNICIPIO,
        text: u.NM_NOME,
      }));
    } catch (e: any) {
      this.listaMunicipios = [];
      this.tratarError(e);
    } finally {
      this.loadingMunicipios = false;
    }
  }

  async salvarNovoUsuario(): Promise<void> {
    store.blockScreen = true;
    try {
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver)
        this.$toast.error('Cadastro inválido!\nVerifique os campos.')
        return
      };
      if (this.novoUsuario.SENHA !== this.confirmaSenha) {
        this.$toast.error("Os campos de Senha e Confirmação de senha possuem valores diferentes");
        return
      }
      const retorno = await usuarioService.updateComCertificado(this.novoUsuario);
      this.logarUsuario(retorno)
    } catch (e: any) {
      if (e.response && e.response.data && e.response.data.message) {
        this.tratarError(new PortalError(e.response.data.message));
      } else {
        console.error('Erro ao salvar novo usuário', e, e.stack);
        this.$toast.error('Erro ao salvar novo usuário!\nPor favor tente novamente em instantes.')
      }
    } finally {
      store.blockScreen = false;
    }
  }
  logarUsuario(ld: LoginData): void {
    if (ld.termosPendentes && ld.termosPendentes.length) store.termoPendente = ld.termosPendentes[0];
    updateToken(ld.token, ld.cpf, null, ld.nomeUsuario, ld.primeiroAcesso, ld.permissoes, null, ld.email, ld.nextStep, ld.idUsuario)
    if (ld.nextStep === 'index') {
      this.$router.push("/inicio");
    } else {
      this.$toast.error('Erro na autenticação, por favor tente novamente!')
    }
  }
}
</script>

<style scoped>
.telaCadastro {
  font-family: "Montserrat", sans-serif;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep div.vti__dropdown {
  display: none;
}
</style>
